export const WHATSAPP_LINK = "https://wa.me/message/CPZJFHPCCSBMH1";

export const orderLabel = (type) => (type === "collective" ? "Match Collectif" : "Match Individuel");

export const userCreditCount = (user) => (
  Number(user?.free_credits || 0) +
  Number(user?.subscription_credits || 0) +
  Number(user?.analysis_credits?.collective || 0) +
  Number(user?.analysis_credits?.individual || 0)
);

export const formatDate = (value) => {
  if (!value) return "Non renseigné";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Non renseigné" : date.toLocaleDateString("fr-FR");
};

export const getRemainingDays = (deadline) => {
  const diff = new Date(deadline) - new Date();
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return days > 0 ? days : 0;
};

export const sortOrdersForDashboard = (orders) => {
  const orderRank = { pending: 0, in_progress: 1, delivered: 2 };
  return [...orders].sort((a, b) => {
    const rankDiff = (orderRank[a.status] ?? 9) - (orderRank[b.status] ?? 9);
    if (rankDiff) return rankDiff;
    return new Date(b.created_at) - new Date(a.created_at);
  });
};
